export default class OpeningHours {
    static format(hours) {
        if (hours) { 
            return this.fill(hours)
                .map((o) => ({ day: this.day(o), times: this.times(o) })) // Replace day number with day name (e.g. 1 -> Monday) and combine openTime and closeTime into a single string separated by slash (e.g. 9:00 - 18:00)
                .reduce((grouped, o) => this.group(grouped, o), []) // Group sequential days if they have the same open and closing times
                .map((o) => ({ day: this.dash(o), times: o.times })); // Format grouped days (e.g. "Monday - Thursday") from ([Monday, Tuesday, Wednesday, Thursday])
        }
        return [];
    }

    static fill(hours) {
        const labels = hours.map(h => h.daysOfWeekLabels).find(l => l);
        return [...Array(7).keys()]
            .map(i => hours.find(h => h.day === i + 1) || this.blank(i + 1, labels)); 
    }

    static blank(day, labels) {
        return { day: day, dayOpeningHoursList: [], daysOfWeekLabels: labels }
    }

    static day(o) {
        return [o.daysOfWeekLabels[o.day - 1]];
    }

    static times(o) {
        return o.dayOpeningHoursList.map((h) => `${h.openTime} &ndash; ${h.closeTime}`).join('<br/>') || '';
    }

    static dash(o) {
        return _.uniq([_.first(o.day), _.last(o.day)]).join(' &ndash; ');
    }

    static group(grouped, o) {
        const prev = grouped[grouped.length - 1];
        !prev ? grouped.push(o) : prev.times == o.times ? prev.day.push(o.day[0]) : grouped.push(o);
        return grouped;
    }

    static html(hours, closedLabel) {
        return hours ? hours.map((o) => `<div class="flex-wrapper"><div class="column">${o.day}</div><div class="column">${o.times || closedLabel}</div></div>`).join('') : '';
    }
}
